import React from 'react';
import { connect } from 'react-redux';
import _ from 'underscore';

import Loader from '../../../../../Shared/components/loader';
import KnowledgeArticles from './knowledgeArticles';

import TextInput from '../../../../../Shared/components/Input/textInput';
import WbmForm from '../../../../../Shared/components/Input/WbmForm';

import ConfigPropId from '../../../../../Shared/constants/configPropId';
import ConfigPropMapService from '../../../../../Shared/services/configPropMapService';

import { loadCrmArticles } from '../../actions/payloadActions';

class CRMSearchBar extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.noResultsErrMessage = (input) => `No results found for "${input}"`;
        this.apiErrorMessage = "Sorry, we ran into an issue while attempting to retrieve your results.";
        this.minCharsErrorText = "Your search must be at least 2 characters long";

        this.searchbarName = "Your search";
        this.onFormSubmit = _.debounce(this.onFormSubmit.bind(this), 500);
        this.handleChange = this.handleChange.bind(this);
        this.handleValidation = this.handleValidation.bind(this);

        this.state = {
            searchString: '',
            isLoading: false,
            isApiErrored: false,
            validationErrors: [],
            searchPerformedForString: false,
            lastSearchedString: ''
        };
    }

    handleChange(event) {
        this.setState({
            searchString: event.target.value
        });
    }

    handleValidation(isValid, errs) {
        let errsForSearchBar = errs.filter(x => x.inputName === this.searchbarName);

        if (errsForSearchBar.length > 0) {
            this.setState({
                validationErrors: errsForSearchBar[0].validationErrors,
                searchPerformedForString: false,
                isApiErrored: false
            });
        }
    }

    onFormSubmit(event) {
        this.setState({ isLoading: true, isApiErrored: false });

        this.props.loadCrmArticles(this.state.searchString)
            .then(x => this.setState({
                isLoading: false,
                isApiErrored: false,
                searchPerformedForString: true,
                lastSearchedString: this.state.searchString
            }))
            .catch(x => this.setState({
                isLoading: false,
                isApiErrored: true,
                searchPerformedForString: false
            }));
    }

    displayResult() {
        let crmArticleArr = this.props.crmArticles;
        let result = null;

        if (this.state.isApiErrored) {
            result = this.getFormattedErrorMessage(this.apiErrorMessage, true);
        }
        else if (this.state.searchPerformedForString) {
            result = (crmArticleArr && crmArticleArr.length > 0) ?
                <KnowledgeArticles data={crmArticleArr} /> :
                this.getFormattedErrorMessage(this.noResultsErrMessage(this.state.lastSearchedString), true);
        }
        else if (this.state.validationErrors.length > 0) {
            let firstError = this.state.validationErrors[0];

            result = this.getFormattedErrorMessage(firstError, firstError !== this.minCharsErrorText);
        }

        return result;
    }

    getFormattedErrorMessage(errMessage, showCSRText) {

        return <div>
        <span className="error-message">{errMessage}</span>
        {
            showCSRText && <div className="italic">
                Please try again or contact your {this.props.CSRRepTitle} above.
                <br />
                You can also click the “Live Chat” button for immediate assistance.
            </div>
        }
        </div>;
    }

    getHeader(text) {
        return text && <h3 className="dynamic-vertical-header contact-us-header">{text}</h3>;
    }

    render() {
        let isSearchEnabled = ConfigPropMapService.getConfigPropbyId(ConfigPropId.DisplaySearchBarOnContactUs).value;
        let searchBarHeaderText = ConfigPropMapService.getConfigPropbyId(ConfigPropId.ContactUsSearchBarHeader).value;
        let searchbarGhostText = ConfigPropMapService.getConfigPropbyId(ConfigPropId.ContactUsSearchBarReplacementText).value;

        return isSearchEnabled && <React.Fragment>
            <div className="searchbar-header">
                {this.getHeader(searchBarHeaderText)}
            </div>
            <div className="search-finder blue-search contact-us-search">
                <WbmForm
                    onError={this.handleValidation}
                    onSubmit={this.onFormSubmit}
                >
                    <TextInput
                        isRequired={{ messageOnError: (input) => this.noResultsErrMessage(input) }}
                        minChars={{ minChars: 2, messageOnError: () => this.minCharsErrorText }}
                        checkForInvalidChars
                        preventInvalidCharsOnKeypress
                        onChange={this.handleChange}
                        value={this.state.searchString}
                        aria-label="Knowledge Article Search Bar"
                        name={this.searchbarName}
                        placeholder={searchbarGhostText}
                        className="search-keyword contact-us-search"
                        type="text"
                        maxLength="250"
                    />
                    <input
                        type="submit"
                        value="search"
                        name="SearchButton"
                        className="search-button"
                        alt="Search Button"
                    />
                </WbmForm>
            </div>
            <div className="results-placeholder">
                {this.state.isLoading ? <Loader /> : this.displayResult()}
            </div>
        </React.Fragment>;
    }
}
function mapStateToProps(state) {
    return {
        crmArticles: state.crmArticles
    };
}
function mapDispatchToProps(dispatch) {
    return {
        loadCrmArticles: (e) => dispatch(loadCrmArticles(e))
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(CRMSearchBar);
